/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { PatchLeadByExternalIdDataMutationRequest, PatchLeadByExternalIdDataMutationResponse, PatchLeadByExternalIdDataPathParams, PatchLeadByExternalIdData400, PatchLeadByExternalIdData401, PatchLeadByExternalIdData403, PatchLeadByExternalIdData404, PatchLeadByExternalIdData503 } from "../models/PatchLeadByExternalIdData";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const patchLeadByExternalIdDataMutationKey = () => [{ url: '/api/v1/contact/leads/by-external-id/:externalId/data' }] as const

export type PatchLeadByExternalIdDataMutationKey = ReturnType<typeof patchLeadByExternalIdDataMutationKey>

/**
 * @description Updates vehicle attributes, financial fields, location, condition report, or sell timeline for a lead. Looks up by the Lease End external deal ID instead of UUID.
 * @summary Update lead data (driver) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/data}
 */
export async function patchLeadByExternalIdData({ externalId, data }: { externalId: PatchLeadByExternalIdDataPathParams["externalId"]; data?: PatchLeadByExternalIdDataMutationRequest }, config: Partial<RequestConfig<PatchLeadByExternalIdDataMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PatchLeadByExternalIdDataMutationResponse, ResponseErrorConfig<PatchLeadByExternalIdData400 | PatchLeadByExternalIdData401 | PatchLeadByExternalIdData403 | PatchLeadByExternalIdData404 | PatchLeadByExternalIdData503>, PatchLeadByExternalIdDataMutationRequest>({ method : "PATCH", url : `/api/v1/contact/leads/by-external-id/${externalId}/data`, data : requestData, ... requestConfig })
  return res
}

export function patchLeadByExternalIdDataMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PatchLeadByExternalIdDataMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = patchLeadByExternalIdDataMutationKey()
        return mutationOptions<ResponseConfig<PatchLeadByExternalIdDataMutationResponse>, ResponseErrorConfig<PatchLeadByExternalIdData400 | PatchLeadByExternalIdData401 | PatchLeadByExternalIdData403 | PatchLeadByExternalIdData404 | PatchLeadByExternalIdData503>, {externalId: PatchLeadByExternalIdDataPathParams["externalId"], data?: PatchLeadByExternalIdDataMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ externalId, data }) => {
            return patchLeadByExternalIdData({ externalId, data }, config)
          },
        })

}

/**
 * @description Updates vehicle attributes, financial fields, location, condition report, or sell timeline for a lead. Looks up by the Lease End external deal ID instead of UUID.
 * @summary Update lead data (driver) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/data}
 */
export function usePatchLeadByExternalIdData<TContext>(options: 
{
  mutation?: UseMutationOptions<ResponseConfig<PatchLeadByExternalIdDataMutationResponse>, ResponseErrorConfig<PatchLeadByExternalIdData400 | PatchLeadByExternalIdData401 | PatchLeadByExternalIdData403 | PatchLeadByExternalIdData404 | PatchLeadByExternalIdData503>, {externalId: PatchLeadByExternalIdDataPathParams["externalId"], data?: PatchLeadByExternalIdDataMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PatchLeadByExternalIdDataMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? patchLeadByExternalIdDataMutationKey()

          const baseOptions = patchLeadByExternalIdDataMutationOptions(config) as UseMutationOptions<ResponseConfig<PatchLeadByExternalIdDataMutationResponse>, ResponseErrorConfig<PatchLeadByExternalIdData400 | PatchLeadByExternalIdData401 | PatchLeadByExternalIdData403 | PatchLeadByExternalIdData404 | PatchLeadByExternalIdData503>, {externalId: PatchLeadByExternalIdDataPathParams["externalId"], data?: PatchLeadByExternalIdDataMutationRequest}, TContext>
          

          return useMutation<ResponseConfig<PatchLeadByExternalIdDataMutationResponse>, ResponseErrorConfig<PatchLeadByExternalIdData400 | PatchLeadByExternalIdData401 | PatchLeadByExternalIdData403 | PatchLeadByExternalIdData404 | PatchLeadByExternalIdData503>, {externalId: PatchLeadByExternalIdDataPathParams["externalId"], data?: PatchLeadByExternalIdDataMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ResponseConfig<PatchLeadByExternalIdDataMutationResponse>, ResponseErrorConfig<PatchLeadByExternalIdData400 | PatchLeadByExternalIdData401 | PatchLeadByExternalIdData403 | PatchLeadByExternalIdData404 | PatchLeadByExternalIdData503>, {externalId: PatchLeadByExternalIdDataPathParams["externalId"], data?: PatchLeadByExternalIdDataMutationRequest}, TContext>
      
}